export default "__VITE_ASSET__C1$V646H__"